<div class="content-card">
  <div class="name">
    <ng-content select="[title]"></ng-content>
  </div>

  <ng-content select="[static-info]"> </ng-content>

  <ng-content select="[expanded-info]"> </ng-content>

  <ng-container *ngIf="showButton">
    <div
      mb-expandable-text
      height="auto"
      (collapse)="onClickViewMore(viewLess)"
      (expand)="onClickViewMore(viewLess)"
      class="expanContainer"
    >
      <span mb-expand i18n="@@ver_mas">Ver más</span>
      <span mb-collapse i18n="@@ver_menos">Ver menos</span>
    </div>
  </ng-container>
</div>
